var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "UploadFile-container" },
    [
      _c(
        "el-upload",
        {
          ref: "elUpload",
          attrs: {
            action: _vm.define.comUploadUrl + "/" + _vm.type,
            headers: _vm.uploadHeaders,
            "on-success": _vm.handleSuccess,
            multiple: _vm.limit !== 1,
            "show-file-list": false,
            accept: _vm.accept,
            "before-upload": _vm.beforeUpload,
            "on-exceed": _vm.handleExceed,
            disabled: _vm.disabled,
            limit: _vm.limit,
          },
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                icon: "el-icon-upload",
                disabled: _vm.disabled,
              },
            },
            [_vm._v(_vm._s(_vm.buttonText))]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showTip,
                  expression: "showTip",
                },
              ],
              staticClass: "el-upload__tip",
              attrs: { slot: "tip" },
              slot: "tip",
            },
            [
              _vm._v(
                "\n      只能上传不超过" +
                  _vm._s(_vm.fileSize) +
                  _vm._s(_vm.sizeUnit) +
                  "的" +
                  _vm._s(_vm.accept) +
                  "文件\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm.fileList.length
        ? [
            _c(
              "transition-group",
              {
                staticClass:
                  "el-upload-list el-upload-list el-upload-list--text",
                attrs: { tag: "ul", name: "el-list" },
              },
              _vm._l(_vm.fileList, function (file, index) {
                return _c(
                  "li",
                  {
                    key: file.fileId,
                    staticClass: "el-upload-list__item is-success",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "el-upload-list__item-name",
                        on: {
                          click: function ($event) {
                            return _vm.handleClick(file)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "el-icon-document" }),
                        _vm._v(_vm._s(file.name) + "\n        "),
                      ]
                    ),
                    _c(
                      "label",
                      { staticClass: "el-upload-list__item-status-label" },
                      [
                        _c("i", {
                          staticClass:
                            "el-icon-upload-success el-icon-circle-check",
                        }),
                      ]
                    ),
                    !_vm.disabled
                      ? _c("i", {
                          staticClass: "el-icon-close",
                          on: {
                            click: function ($event) {
                              return _vm.handleRemove(file, index)
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }